const email = (import.meta.env.VITE_CONTACT_EMAIL ?? 'uj2535@gmail.com').trim();
const endpoint = import.meta.env.VITE_CONTACT_FORM_ENDPOINT?.trim() || '';
export const CONTACT_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ? email : '';
export const CONTACT_FORM_ENDPOINT = /^https:\/\/formspree\.io\/f\/[a-z0-9]+$/i.test(endpoint) ? endpoint : '';
export const CONTACT_AVAILABLE = Boolean(CONTACT_EMAIL || CONTACT_FORM_ENDPOINT);
